export enum LogLevelEnum {
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4
}